// Create the notification portal
const notificationsPortal = document.createElement('div');
notificationsPortal.id = 'notifications-portal';
document.body.appendChild(notificationsPortal);

// The dialog portal is created by ui widgets and this is a special case for print area editor.
const dialogsPortal = document.getElementById('dialogs-portal')!;

// Create the color picker portal
const colorPickerPortal = document.createElement('div');
colorPickerPortal.id = 'color-picker-portal';
document.body.appendChild(colorPickerPortal);

export { colorPickerPortal, dialogsPortal, notificationsPortal };
